module.exports = __webpack_public_path__ + "static/media/buy-left-img.c18c9686.png";